/* ══════════════════════════════════════════════════════════════════════════
   CARD ALERTS — assets/monmouth-card-alerts.js

   Opened only from the inline strip. NO auto-fire: no scroll trigger, no
   dwell timer, no exit intent. An interruption competes with the promo
   popup and this converts better as a deliberate click.

   Three steps. Step 1 asks one easy thing. Step 2 asks only for the fields
   the chosen channel actually needs. Step 3 tells the visitor what happens next.

   Guests: nothing is live when the form is sent. The server emails a
   confirmation link; alerts switch on and the points are awarded (server-side,
   once per customer) when they click it. So this script never shows points
   as earned and never says "locked in" for a guest.

   The collection page re-renders its whole section on every filter change,
   which replaces the strip (and a <script> inserted that way never runs, so the theme
   also loads this file on every collection page, not only on singles pages). Every
   strip is started in two ways: a MutationObserver starts any strip that appears, and
   a delegated click on [data-ca-open] starts (then opens) one that is somehow not
   started yet. Nothing here binds to a button directly, so a replaced strip cannot
   lose its handler.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* This file can be on a page twice (the theme loads it on every collection page and the snippet adds its own tag):
     run once. */
  if (window.__mcCardAlertsLoaded) return;
  window.__mcCardAlertsLoaded = true;

  var DRAFT_KEY = 'mc_card_alerts_draft';
  function init(root) {
    if (!root) return null;
    if (root.__ca) return root.__ca;
    root.dataset.caInit = '1';

    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

    var SIGNED_IN  = root.getAttribute('data-signed-in') === '1';
    var CUST_EMAIL = root.getAttribute('data-customer-email') || '';
    var TAG_CAP    = parseInt(root.getAttribute('data-tag-cap'), 10) || 25;
    var POINTS     = parseInt(root.getAttribute('data-points'), 10) || 100;
    var PUBLIC_API = root.getAttribute('data-public-api');

    var dlg = $('[data-ca-dlg]'), ovl = $('[data-ca-ovl]');
    var tagsBox = $('[data-ca-tags]'), input = $('[data-ca-input]');
    /* A strip without its popup would be a button that does nothing: hide it instead of showing a dead button. */
    if (!dlg || !ovl || !tagsBox || !input || !$('[data-ca-next]') || !$('[data-ca-submit]')) {
      root.hidden = true;
      root.style.display = 'none';
      if (window.console && console.warn) console.warn('Card Alerts: popup markup missing, strip hidden');
      root.__ca = { open: function(){}, addTag: function(){} };
      return root.__ca;
    }
    var tags = [], channel = 'email', step = 1, lastFocus = null, sending = false;

    function esc(s){var d=document.createElement('div');d.textContent=s==null?'':String(s);return d.innerHTML;}
    function announce(m){ var l=$('[data-ca-live]'); if(l) l.textContent = m; }

    /* ── draft (typed tags + channel survive a close, an error and a section re-render) ── */
    function saveDraft(){ try{ sessionStorage.setItem(DRAFT_KEY, JSON.stringify({tags:tags,channel:channel})); }catch(e){} }
    function loadDraft(){
      try{ var d=JSON.parse(sessionStorage.getItem(DRAFT_KEY)||'{}');
        if(d.tags&&d.tags.length) tags=d.tags.slice(0,TAG_CAP);
        if(d.channel) channel=d.channel;
      }catch(e){}
    }
    function clearDraft(){ try{ sessionStorage.removeItem(DRAFT_KEY); }catch(e){} }

    /* ── milestones: the gamified bit, tied to something real ── */
    var MILES = [
      { at:0, lvl:'',     t:'Add your first player or team',  s:'Tracking 0 of '+TAG_CAP },
      { at:1, lvl:'lvl1', t:'Good start',                     s:'Add a couple more to widen the net' },
      { at:3, lvl:'lvl1', t:"Now you're hunting",             s:'Three searches running around the clock' },
      { at:5, lvl:'lvl2', t:'Serious collector',              s:"You'll see most of what matches, fast" }
    ];
    function paintMilestone(){
      var m = MILES[0];
      for (var i=0;i<MILES.length;i++) if (tags.length >= MILES[i].at) m = MILES[i];
      var box = $('[data-ca-mile]');
      box.className = 'ca-mile ' + m.lvl;
      $('[data-ca-mile-t]').textContent = m.t;
      $('[data-ca-mile-s]').textContent = tags.length
        ? (m.s + ' · tracking ' + tags.length + ' of ' + TAG_CAP)
        : m.s;
    }

    /* ── tags ── */
    function addTag(raw){
      var v = String(raw||'').trim().replace(/,+$/,'').replace(/\s+/g,' ');
      if(!v) return;
      if(v.length>60) v=v.slice(0,60);
      if(tags.some(function(t){return t.toLowerCase()===v.toLowerCase();})){ announce(v+' is already on your list'); return; }
      if(tags.length>=TAG_CAP){ showError('[data-ca-error]','You can track up to '+TAG_CAP+' alerts at a time.'); return; }
      tags.push(v); renderTags(); saveDraft(); hideError('[data-ca-error]');
      announce('Added '+v+'. Tracking '+tags.length+'.');
    }
    function removeTag(i){ var g=tags.splice(i,1)[0]; renderTags(); saveDraft(); announce('Removed '+g); }
    function renderTags(){
      $$('.ca-chip', tagsBox).forEach(function(c){c.remove();});
      tags.forEach(function(t,i){
        var c=document.createElement('span'); c.className='ca-chip';
        c.innerHTML='<span>'+esc(t)+'</span><button type="button" data-ca-rm="'+i+'" aria-label="Remove '+esc(t)+'">&times;</button>';
        tagsBox.insertBefore(c,input);
      });
      $$('[data-ca-add]').forEach(function(b){
        var v=b.getAttribute('data-ca-add').toLowerCase();
        b.hidden = tags.some(function(t){return t.toLowerCase()===v;});
      });
      paintMilestone();
      $('[data-ca-next]').disabled = tags.length === 0;
    }

    input.addEventListener('keydown', function(e){
      if(e.key==='Enter'||e.key===','){ e.preventDefault(); addTag(this.value); this.value=''; }
      else if(e.key==='Backspace' && !this.value && tags.length){ removeTag(tags.length-1); }
    });
    /* a comma typed or pasted anywhere (mobile keyboards often send no keydown for it) ends a tag */
    input.addEventListener('input', function(){
      if(this.value.indexOf(',')===-1) return;
      var parts=this.value.split(',');
      var rest=parts.pop();
      parts.forEach(addTag);
      this.value=rest;
    });
    input.addEventListener('blur', function(){ if(this.value.trim()){ addTag(this.value); this.value=''; } });
    tagsBox.addEventListener('click', function(e){
      var rm=e.target.closest('[data-ca-rm]');
      if(rm){ removeTag(parseInt(rm.getAttribute('data-ca-rm'),10)); return; }
      if(e.target===tagsBox) input.focus();
    });
    $$('[data-ca-add]').forEach(function(b){
      b.addEventListener('click', function(){ addTag(b.getAttribute('data-ca-add')); });
    });

    /* ── validation helpers ── */
    var phoneEl=$('[data-ca-phone]'), emailEl=$('[data-ca-email]'), webEl=$('[data-ca-website]'), joinEl=$('[data-ca-join]');
    function digits(v){ return (v||'').replace(/\D/g,'').slice(0,10); }
    function pretty(v){
      var d=digits(v);
      if(d.length<4) return d;
      if(d.length<7) return '('+d.slice(0,3)+') '+d.slice(3);
      return '('+d.slice(0,3)+') '+d.slice(3,6)+'-'+d.slice(6);
    }
    function fieldOk(el){ el.removeAttribute('aria-invalid'); var e=el.parentNode.querySelector('.ca-err'); if(e)e.remove(); }
    function fieldBad(el,msg){ fieldOk(el); el.setAttribute('aria-invalid','true');
      var p=document.createElement('p'); p.className='ca-err'; p.textContent=msg; el.parentNode.appendChild(p); }
    function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v||'').trim()); }
    /* Guests always give an email (the confirmation link goes there), whatever channel they pick. Phone only for text/both. */
    function emailRequired(){ return !SIGNED_IN; }
    function phoneRequired(){ return channel==='sms'||channel==='both'; }

    /* ── channel: the email field always shows for guests; phone + consent only for text/both ── */
    function paintChannel(){
      $$('[data-ca-chan]').forEach(function(x){
        x.setAttribute('aria-pressed', String(x.getAttribute('data-ca-chan')===channel));
      });
      var needP = phoneRequired();
      var pf=$('[data-ca-f-phone]'); if(pf) pf.hidden = !needP;
      var cs=$('[data-ca-sms-consent]'); if(cs) cs.hidden = !needP;
      syncSubmit();
    }
    $$('[data-ca-chan]').forEach(function(b){
      b.addEventListener('click', function(){ channel=b.getAttribute('data-ca-chan'); saveDraft(); paintChannel(); });
    });
    if(phoneEl) phoneEl.addEventListener('input', function(){
      var atEnd=this.selectionStart===this.value.length;
      this.value=pretty(this.value);
      if(atEnd) this.setSelectionRange(this.value.length,this.value.length);
      fieldOk(this); syncSubmit();
    });
    if(emailEl && !SIGNED_IN) emailEl.addEventListener('input', function(){ fieldOk(this); syncSubmit(); });

    function syncSubmit(){
      var ok = tags.length>0 && !sending;
      if(emailRequired() && !(emailEl && validEmail(emailEl.value))) ok=false;
      if(phoneRequired() && !(phoneEl && digits(phoneEl.value).length===10)) ok=false;
      $('[data-ca-submit]').disabled = !ok;
    }

    function showError(sel,msg){ var e=$(sel); if(!e)return; e.textContent=msg; e.hidden=false; }
    function hideError(sel){ var e=$(sel); if(e) e.hidden=true; }

    /* ── steps ── */
    var HEAD = {
      1:['Step 1 of 3','Who are you <em>hunting?</em>','Add any player, team or set. We watch every new listing and reach you the moment one matches.'],
      2:['Step 2 of 3','Where do we <em>find you?</em>','Texts land within seconds. Email is close behind.'],
      3:['Done','Check your <em>email.</em>','']
    };
    function goStep(n){
      step = n;
      [1,2,3].forEach(function(i){
        var pane=$('[data-ca-pane="'+i+'"]'); if(pane) pane.hidden = (i!==n);
        var foot=$('[data-ca-foot="'+i+'"]'); if(foot) foot.hidden = (i!==n);
      });
      $('[data-ca-step-label]').textContent = HEAD[n][0];
      $('[data-ca-title]').innerHTML = HEAD[n][1];
      var sub=$('[data-ca-sub]'); sub.innerHTML = HEAD[n][2]; sub.hidden = !HEAD[n][2];
      $$('[data-rail]').forEach(function(r){
        r.classList.toggle('on', parseInt(r.getAttribute('data-rail'),10) <= n);
      });
      var rw=$('[data-ca-reward]'); if(rw) rw.hidden = (n===3);
      dlg.scrollTop = 0;
      var body = $('[data-ca-pane="'+n+'"]'); if(body) body.scrollTop = 0;
      if(n===2) paintChannel();
      setTimeout(function(){
        var f = n===1 ? input : $('[data-ca-pane="'+n+'"] button, [data-ca-pane="'+n+'"] input:not([tabindex="-1"])');
        if(f) f.focus({preventScroll:true});
      }, 80);
    }
    $('[data-ca-next]').addEventListener('click', function(){ if(tags.length) goStep(2); });
    $('[data-ca-back]').addEventListener('click', function(){ goStep(1); });

    /* ── submit ── */
    $('[data-ca-submit]').addEventListener('click', function(){
      var btn=this; hideError('[data-ca-error2]');
      if(sending) return;
      if(emailRequired() && !(emailEl && validEmail(emailEl.value))){ if(emailEl){ fieldBad(emailEl,'We need a valid email.'); emailEl.focus(); } return; }
      if(phoneRequired() && !(phoneEl && digits(phoneEl.value).length===10)){ if(phoneEl){ fieldBad(phoneEl,'Enter a 10-digit US mobile number.'); phoneEl.focus(); } return; }
      sending=true; btn.disabled=true; var label=btn.textContent; btn.textContent='Setting up…';
      var emailUsed = SIGNED_IN ? CUST_EMAIL : emailEl.value.trim().toLowerCase();
      submit(emailUsed)
        .then(function(res){ sending=false; btn.textContent=label; showDone(res||{}, emailUsed); clearDraft(); })
        .catch(function(err){
          /* keep the draft and every typed value; give the button back */
          sending=false; btn.textContent=label; syncSubmit();
          showError('[data-ca-error2]', (err&&err.message)||'We could not set that up just now. Please try again.');
          var e2=$('[data-ca-error2]'); if(e2 && e2.scrollIntoView) e2.scrollIntoView({block:'nearest'});
        });
    });

    function submit(email){
      /* Signed-in visitors: the account page's own flow if it is loaded. It only exists on My Account, so on these
         pages they use the same public endpoint, with their account email. */
      if(SIGNED_IN && typeof window.wlCreateTag==='function'){
        tags.forEach(function(t){ window.wlCreateTag(t); });
        return Promise.resolve({ok:true, local:true});
      }
      var consentEl = $('[data-ca-sms-consent]');
      var wantsSms = channel==='sms'||channel==='both';
      var body = {
        tags: tags, email: email,
        phone: phoneRequired() ? digits(phoneEl.value) : null,
        channel: channel,
        sms_consent: wantsSms,
        sms_consent_text: wantsSms && consentEl ? consentEl.textContent.replace(/\s+/g,' ').trim() : '',
        join_club: SIGNED_IN ? false : !!(joinEl && joinEl.checked),
        source: 'card_alerts_popup',
        source_url: location.pathname,
        website: webEl ? webEl.value : ''
      };
      return post(body);
    }

    function post(body){
      return fetch(PUBLIC_API,{
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify(body)
      }).then(function(r){
        return r.json().catch(function(){return {};}).then(function(d){
          if(r.status===429) throw new Error('Too many attempts. Please try again in a little while.');
          if(!r.ok || (d && d.ok===false)) throw new Error((d&&d.error)||'Could not set up your alerts. Please try again.');
          return d;
        });
      }, function(){ throw new Error('We could not reach the server. Check your connection and try again.'); });
    }

    /* ── done ──
       Guest (or anyone the server says is pending): "Check your email". Points are never shown as earned. */
    function showDone(res, email){
      goStep(3);
      var pending = !!res.pending_verification;
      var wantsPts = parseInt(res.points_pending,10) || 0;
      var how = channel==='both' ? 'by text and email' : channel==='sms' ? 'by text' : 'by email';
      var title=$('[data-ca-title]'), t3=$('[data-ca-done-title]'), sub=$('[data-ca-done-sub]');
      var label=$('[data-ca-done-label]'), howEl=$('[data-ca-done-how]');
      var ic1=$('[data-ca-ic-mail]'), ic2=$('[data-ca-ic-ok]');

      if(pending){
        title.innerHTML = 'Check your <em>email.</em>';
        t3.textContent = 'Confirmation link sent';
        var pts = wantsPts > 0 ? ' and add your <b>'+esc(wantsPts)+' points</b>' : '';
        sub.innerHTML = 'We sent a confirmation link to <b>'+esc(email)+'</b>. Tap it to switch your alerts on'+pts+'.';
        label.textContent = 'Waiting for your confirmation:';
        howEl.innerHTML = 'Once you confirm, we&rsquo;ll reach you <b>'+how+'</b> within seconds of a matching card going live.';
        ic1.hidden=false; ic2.hidden=true;
        announce('Check your email. We sent a confirmation link to '+email+'.');
      } else {
        title.innerHTML = 'You&rsquo;re <em>all set.</em>';
        t3.textContent = 'Your alerts are set up';
        sub.innerHTML = 'We&rsquo;ll reach you <b>'+how+'</b> within seconds of a matching card going live.';
        label.textContent = '';
        howEl.textContent = '';
        ic1.hidden=true; ic2.hidden=false;
        announce('Your alerts are set up for '+tags.length+' search'+(tags.length===1?'':'es')+'.');
      }
      label.hidden = !label.textContent;
      howEl.hidden = !howEl.textContent;
      $('[data-ca-done-list]').innerHTML = tags.map(function(t){ return '<span>'+esc(t)+'</span>'; }).join('');
      $('[data-ca-manage]').hidden = !SIGNED_IN;
    }

    /* ── dialog ── */
    function focusables(){
      return $$('a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"]),[tabindex]:not([tabindex="-1"])',dlg)
        .filter(function(n){ return n.offsetParent!==null; });
    }
    function open(){
      lastFocus=document.activeElement;
      dlg.hidden=false; ovl.classList.add('is-on');
      requestAnimationFrame(function(){ dlg.classList.add('is-on'); });
      document.body.style.overflow='hidden';
      renderTags(); goStep(tags.length ? 2 : 1);
    }
    function close(){
      dlg.classList.remove('is-on'); ovl.classList.remove('is-on');
      document.body.style.overflow='';
      setTimeout(function(){ dlg.hidden=true; },200);
      if(lastFocus&&lastFocus.focus&&document.contains(lastFocus)) lastFocus.focus();
    }
    $$('[data-ca-close]').forEach(function(b){ b.addEventListener('click', close); });
    ovl.addEventListener('click', close);

    function onKey(e){
      if(!root.isConnected){ document.removeEventListener('keydown', onKey); return; }
      if(dlg.hidden) return;
      if(e.key==='Escape'){ e.preventDefault(); close(); return; }
      if(e.key!=='Tab') return;
      var f=focusables(); if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', onKey);

    root.__ca = {
      open: function(seed){ if(seed) addTag(seed); open(); },
      addTag: addTag
    };

    loadDraft(); renderTags();
    return root.__ca;
  }

  /* one listener for every strip, present or future */
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest ? e.target.closest('[data-ca-open]') : null;
    if (!b) return;
    var root = b.closest('[data-card-alerts]');
    if (!root) return;
    var api = init(root);
    if (api) api.open();
  });

  /* public hook: MonmouthCardAlerts.open('Aaron Judge') */
  window.MonmouthCardAlerts = {
    open: function(seed){
      var root = document.querySelector('[data-card-alerts]');
      var api = root && init(root);
      if (api) api.open(seed);
    },
    addTag: function(seed){
      var root = document.querySelector('[data-card-alerts]');
      var api = root && init(root);
      if (api) api.addTag(seed);
    }
  };

  function initAll(){
    var roots = document.querySelectorAll('[data-card-alerts]');
    for (var i=0;i<roots.length;i++) init(roots[i]);
  }

  /* the collection page swaps its whole section on filter changes: start up any strip that appears later */
  var pending = false;
  function watch(){
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function(){
      if (pending) return;
      pending = true;
      setTimeout(function(){ pending = false; initAll(); }, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(); watch(); });
  } else { initAll(); watch(); }
})();
